export default {
  register: {
    title: 'Cadastrar',
    username: 'Nome de usuário',
    phone: 'Número de telefone',
    phoneCode: 'Código',
    email: 'E-mail',
    password: 'Senha',
    captcha: 'Captcha',
    smsCode: 'Código SMS',
    emailCode: 'Código de E-mail',
    verificationCode: 'Código de e-mail',
    invitationCode: 'Código de Convite',
    loading: 'Carregando...',
    send: 'Enviar',
    sendCode: 'Enviar Código',
    signUp: 'Cadastrar',
    contactUs: 'Fale Conosco？',
    haveAccount: 'Já tem uma conta?',
    signIn: 'Entrar',
    loginNow: 'Entrar',
    or: 'OU',
    orSignUpWith: 'Ou cadastre-se com',
    methodUsername: 'Nome de usuário',
    methodPhone: 'Telefone',
    methodEmail: 'E-mail',
    codeOptional: 'Código (Opcional)',
    privacyPolicy: 'Confirmo que tenho mais de 18 anos e aceito a',
    privacyPolicyLink: 'Política de Privacidade',
    and: 'e',
    termsConditions: 'Termos e Condições',
    vault: 'Cofre',
    receivePromos: 'Receber Promoções por E-mail',
    usernameRequired: 'Nome de usuário é obrigatório',
    usernameInvalid: 'Nome de usuário só pode conter letras, números e sublinhados',
    phoneRequired: 'Número de telefone é obrigatório',
    phoneInvalid: 'Formato de número de telefone inválido',
    emailRequired: 'E-mail é obrigatório',
    emailInvalid: 'Formato de e-mail inválido',
    passwordRequired: 'Senha é obrigatória',
    passwordInvalid: 'A senha não atende aos requisitos',
    captchaRequired: 'Captcha é obrigatório',
    smsCodeRequired: 'Código SMS é obrigatório',
    emailCodeRequired: 'Código de e-mail é obrigatório',
    privacyPolicyRequired: 'Por favor, aceite a Política de Privacidade e os Termos e Condições',
    passwordHintLow: 'Pelo menos 6 dígitos',
    passwordHintMedium: 'Pelo menos 6 caracteres com letras e números',
    passwordHintHigh: 'Pelo menos 6 caracteres com letras, números e símbolos',
    // Format validation
    usernameFormat: 'Apenas letras, números e _',
    emailFormat: 'Formato de e-mail inválido',
    // Toast messages
    smsCodeSent: 'Código SMS enviado',
    emailCodeSent: 'Código de e-mail enviado',
    smsCodeFailed: 'Falha ao enviar código SMS',
    emailCodeFailed: 'Falha ao enviar código de e-mail',
    registerSuccess: 'Cadastro realizado com sucesso',
    registerFailed: 'Falha no cadastro',
    // Google sign in
    signInWithGoogle: 'Entrar com Google+'
  }
};
